module.exports = __webpack_public_path__ + "77f86ee9cd7e6fac2c268f5432a2246b.png";